// extracted by mini-css-extract-plugin
export default {"customerTitle":"ConfirmDeleteModal_customerTitle__XnFPw","customerLabel":"ConfirmDeleteModal_customerLabel__m0nbx","customerBtn":"ConfirmDeleteModal_customerBtn__B-unQ"};